<template>
	<div class="payment">
		<v-card class="rounded-lg payment-card" v-if="inProcess">
			<div class="content">
				<h2>Confirmación de pago</h2>

				<p class="my-2">
					Una vez haya completado el proceso de pago pulse
					<b>SIGUIENTE</b>. Si encuentra cualquier error en el
					proceso, contacte con nosotros
				</p>
				<div class="card-actions row">
					<v-spacer></v-spacer>
					<v-btn
						type="submit"
						text=""
						color="success"
						@click="
							$router.push({
								name: 'RaceDetails',
								query: { id: $route.query.id },
								params: {
									checkPayment: true,
								},
							})
						"
						>Siguiente</v-btn
					>
				</div>
			</div>
		</v-card>

		<v-card class="rounded-lg payment-card" v-else-if="!alreadyPaid">
			<div class="content">
				<h2>Confirmación de pago</h2>
				<p>
					Se está inscibiendo a la carrera <b>{{ race.name }}</b
					>. El precio de la inscripción es de
					<b>{{ race.price / 100 }}€</b>. Será redirigido a
					continuación a una pasarela de pago seguro.
				</p>

				<form
					ref="form"
					name="from"
					action="https://sis.redsys.es/sis/realizarPago"
					method="POST"
					target="_blank"
				>
					<input
						type="hidden"
						name="Ds_SignatureVersion"
						:value="Ds_SignatureVersion"
					/>
					<input
						type="hidden"
						name="Ds_MerchantParameters"
						:value="Ds_MerchantParameters"
					/>
					<input
						type="hidden"
						name="Ds_Signature"
						:value="Ds_Signature"
					/>

					<v-checkbox :rules="accepted" v-model="valid">
						<template v-slot:label>
							<span
								>He leído y acepto la

								<a
									href="/politica-privacidad"
									target="_blank"
									@click.stop
									>Política de Privacidad</a
								>
								de CARRERAS KINESIA.</span
							></template
						>
					</v-checkbox>

					<div class="card-actions">
						<v-spacer></v-spacer>
						<v-btn text color="error" @click="$router.go(-1)"
							>Cancelar</v-btn
						>

						<v-btn
							class="rounded-lg"
							elevation="0"
							color="success"
							:disabled="loading || !valid"
							@click="submitForm"
							>Continuar</v-btn
						>
					</div>
				</form>
			</div>

			<div class="privacy-notice">
				<p>
					<b
						>Información básica sobre protección de datos
						(RGPD|LOPD-gdd)
					</b>
					<br /><br />

					Responsable: KINESIA SPORT, S.L. <br />

					Finalidad: Gestión y tramitación del proceso de pago. <br />

					Legitimación: Consentimiento del interesado; Tratamiento
					necesario para la ejecución de un contrato en el que el
					interesado es parte. <br />

					Destinatarios: No se cederán datos a terceros, salvo
					obligación legal. <br />

					Derechos: Acceder, rectificar, limitar y suprimir los datos,
					así como presentar una reclamación ante la autoridad
					nacional de control, como se explica en la información
					adicional. <br />

					Información Adicional: Puede consultar la información
					adicional y detallada sobre Protección de Datos en nuestra
					“Política de Privacidad”.
				</p>
			</div>
		</v-card>

		<v-card class="rounded-lg payment-card" v-else>
			<div class="content">
				<h2>Ya se ha pagado por esta carrera</h2>

				<p>
					Por favor vuelva atrás y refresque la página. En caso de que
					el problema persista, contacte con nosotros. Gracias
				</p>
				<div class="card-actions">
					<v-spacer></v-spacer>
					<v-btn
						type="submit"
						text=""
						color="success"
						@click="
							$router.push({
								name: 'RaceDetails',
								query: { id: $route.query.id },
							})
						"
						>Volver</v-btn
					>
				</div>
			</div>
		</v-card>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "ConfirmPayment",
	data() {
		return {
			loading: false,
			race: {},
			Ds_SignatureVersion: "",
			Ds_MerchantParameters: "",
			Ds_Signature: "",
			alreadyPaid: false,
			inProcess: false,
			valid: false,

			accepted: [(v) => v || "Debe aceptar para continuar"],
		};
	},
	methods: {
		async fetchFormData() {
			try {
				this.$emit("loading", true);
				const response = await axios.get("/payment", {
					params: {
						raceId: this.race.id,
					},
				});

				this.Ds_SignatureVersion = response.data.Ds_SignatureVersion;
				this.Ds_Signature = response.data.Ds_Signature;
				this.Ds_MerchantParameters =
					response.data.Ds_MerchantParameters;

				this.loading = false;
			} catch (error) {
				if (error.response && error.response.status === 401) {
					this.$router.push({
						name: "UserLogin",
						params: {
							redirect: this.$route.fullPath,
						},
					});
				} else if (error.response && error.response.status === 409) {
					this.alreadyPaid = true;
				}
			} finally {
				this.$emit("loading", false);
			}
		},

		/**
		 * Fetches the race
		 */
		async fetchRace() {
			this.$emit("loading", true);
			try {
				const response = await axios.get("race", {
					params: {
						id: this.$route.query.id,
					},
				});

				this.race = response.data;
			} catch (error) {
				//If there is any error, inform the user
				let errorToDisplay;

				//If there is an array of errors
				if (error.response.data instanceof Array) {
					errorToDisplay = "";
					error.response.data.forEach((error) => {
						errorToDisplay += `${error}<br />`;
					});
					//If only one error
				} else if (error.response) {
					errorToDisplay = error.response.data;
					//Rest of the cases
				} else {
					errorToDisplay =
						"Ha ocurrido un error, pruebe más tarde por favor";
				}
				this.$emit("snackbar-event", {
					color: "error",
					text: errorToDisplay,
				});
			} finally {
				this.$emit("loading", false);
			}
		},

		async submitForm() {
			try {
				await this.fetchFormData();
				this.$refs.form.submit();
				this.inProcess = true;
			} catch (error) {
				//
			}
		},
	},
	async mounted() {
		if (!this.$store.getters["user/getUser"].id) {
			this.$router.push({
				name: "UserLogin",
				params: {
					redirect: this.$route.fullPath,
				},
			});
		} else if (!this.$route.query.id) {
			this.$router.push({
				name: "UserMain",
			});
			return;
		}
		await this.fetchRace();
	},
};
</script>

<style lang="scss" scoped>
@import "../../scss/_mixins.scss";
@import "../../scss/_variables.scss";
.payment {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;

	background-color: #f0f0f3;

	.payment-card {
		max-width: 600px;
		height: fit-content;

		.content {
			padding: 2em;
		}

		.privacy-notice {
			background-color: #e6e6ec;
			padding: 2em;
			p {
				text-align: justify;
				font-size: 0.7em;
				margin: 0;
			}
		}

		h2 {
			margin-bottom: 0.5em;
		}

		p {
			text-align: justify;
		}

		form .card-actions {
			padding: 0;
			display: flex;
			margin-top: 1em;
		}
		.card-actions {
			padding: 0;
			display: flex;
			margin-top: 1em;
		}
	}
}
</style>